export const EXTENSION_ID = {
  CHROME: 'eiimnmioipafcokbfikbljfdeojpcgbh',
  EDGE: 'lbnblmjlpifpfpefbcgefbhnlcnnjgjk',
  SAFARI_CHROMEIUM: 'com.BlockSite-Safari.Extension (AVP2498YRZ)',
  SAFARI_IOS: 'com.BlockSite-Safari-IOS.Extension (AVP2498YRZ)',
} as const;

export const EXTENSION_INSTALL_REDIRECT_SECONDS = 5;
export const COUNTDOWN_TICK_MS = 1000;
// leaves time for a sleeping service worker to wake up, a missing extension fails immediately
export const EXTENSION_INFO_TIMEOUT_MS = 3000;

export const EXTENSION_UPDATE_CONFIG_EVENT = 'bs_ext_updateConfig';

export const SUPPORTED_BROWSERS = {
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  MOBILE_SAFARI: 'Mobile Safari',
  MOBILE_CHROME: 'Mobile Chrome',
  EDGE: 'Edge',
} as const;
